import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, SwirlWrapper } from './signupWidgetStyles';
import SignupForm from './SignupForm';
import ThankYou from './ThankYou';
import Errored from './Errored';

import { Container } from 'core/components/Layout';
import Swirls from './Swirls';
import Observer from './Observer';
import { AmpProvider } from 'core/providers/AmpProvider';
import FormLogic from './FormLogic';

const SignupWidgetMarkup = ({
	title,
	subtitle,
	submitText,
	thankYouTitle,
	thankYouMessage,
	success,
	errored,
	errorOnClickBtn,
	onObserve,
	loading,
	redirectUrl,
	submitHandler,
	alreadySubscribed,
	alreadySubscribedTitle,
	alreadySubscribedMessage
}) => (
	<AmpProvider>
		<Observer once onObserve={onObserve}>
			{({ observerRef }) => (
				<Wrapper ref={observerRef}>
					<Container>
						{ errored ? (
							<Errored errorOnClickBtn={errorOnClickBtn} />
						): success ? (
							<ThankYou
								title={alreadySubscribed ? alreadySubscribedTitle : thankYouTitle}
								message={alreadySubscribed ? alreadySubscribedMessage : thankYouMessage}
							/>
						): (
							<FormLogic submitHandler={submitHandler}>
								{({
									formHandler,
									inputChangeHandler,
									inputBlurHandler,
									inputFocusHandler,
									email,
									emailInvalid,
								}) => (
									<SignupForm
										title={title}
										subtitle={subtitle}
										submitText={submitText}
										email={email}
										emailInvalid={emailInvalid}
										formHandler={formHandler}
										inputChangeHandler={inputChangeHandler}
										inputBlurHandler={inputBlurHandler}
										inputFocusHandler={inputFocusHandler}
										loading={loading}
										redirectUrl={redirectUrl}
									/>
								)}
							</FormLogic>
						)}
					</Container>

					<SwirlWrapper>
						<Swirls />
					</SwirlWrapper>
				</Wrapper>
			)}
		</Observer>
	</AmpProvider>
);

SignupWidgetMarkup.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	submitText: PropTypes.string,
	redirectUrl: PropTypes.string,
	thankYouTitle: PropTypes.string,
	thankYouMessage: PropTypes.string,
	alreadySubscribedTitle: PropTypes.string,
	alreadySubscribedMessage: PropTypes.string,
	// Container needed props...
	loading: PropTypes.bool,
	success: PropTypes.bool,
	errored: PropTypes.bool,
	alreadySubscribed: PropTypes.bool,
	submitHandler: PropTypes.func,
	errorOnClickBtn: PropTypes.func,
	onObserve: PropTypes.func,
};

SignupWidgetMarkup.defaultProps = {
	onObserve: () => {},
	title: `Join today for exclusive Offers!`,
	subtitle: `Join our list for special deals, first dibs on new arrivals, and more.`,
	submitText: `Sign Me Up`,
	thankYouTitle: 'Thanks',
	thankYouMessage: 'We\'ll send you an email to confirm your subscription',
	alreadySubscribedTitle: 'Good news!',
	alreadySubscribedMessage: 'You\'re already subscribed to our mailing list',
};

export default SignupWidgetMarkup;
